// Navigation des Moduls `scorecard` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul scorecard.
import { Star } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'scorecard',
  title: 'Scorecards',
  nav: {
    people: [
      {
        key: 'scorecard.tab',
        label: 'Reviews',
        icon: Star,
        path: '/reviews',
        roles: ['LM', 'HOD', 'PERF'],
        order: 20,
        area: 'tabs:performance',
      },
    ],
  },
});
